<template>
    <span>
        <router-link :to="`/employees/view/${employee.EmployeeId}`" v-if="this.$root.hasPermission('employees.view')" title="View Employee">
            {{ name }}
        </router-link>
        <span v-else>
            {{ name }}
        </span>
    </span>
</template>

<script>
    export default {
        props: {
            employee: {
                type: Object,
                required: false
            }
        },

        data: function() {
            return {

            }
        },

        computed: {
            name(){
                return this.employee.EmployeeNumber + ' - ' + this.employee.FirstName + ' ' + this.employee.LastName;
            }
        },

        methods: {


        },

        mounted() {

        }
    }
</script>
